import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import './style.css';

const NotFoundPage = () => (
  <div className="not-found-page">
    <Navbar />
    <main className="not-found-content">
      <div className="not-found-circle">
        <span>404</span>
      </div>
      <p className="not-found-eyebrow">OUPS…</p>
      <h1>Page introuvable</h1>
      <p className="not-found-message">La page que vous recherchez n’existe pas ou a été déplacée.</p>
      <Link className="not-found-button" to="/">Retour à l’accueil</Link>
    </main>
  </div>
);

export default NotFoundPage;
